export default {
  GET_USER_LIST: '/manage/user/findList',
  GET_ROLE_LIST: '/manage/userRole/queryRoleList',
  EXPORT_LIST: '/manage/user/exportList',
  SAVE_USER: '/manage/user/save',
  GET_USER_DETAIL: '/manage/user/findById',
  UPDATE_USER: '/manage/user/update',
  UPDATE_USER_COMPANY: '/manage/userCompany/update',
  RESET_PASSWORD: '/manage/user/resetPassword',
  CHANGE_AUTH: '/manage/user/applyTips',
  GET_DEFAULT_ROLE: '/auth/userRole/findDefaultRole',
  DEREGISTRATION: '/manage/user/deregistrationOperate',
  GET_INACTIVE_LIST: '/manage/user/findInactiveAccountsList',
  EXPORT_INACTIVE_LIST: '/manage/user/inactiveAccountExport',
  MASS_SET_ROLE: '/manage/user/updateRoleForBatch',
  MASS_SET_ACCOUNT: '/manage/user/updateForBatch',
  ANALYSIS_ACCOUNT: '/manage/user/resolve/muti-users',
  DELETE_ROLES: '/manage/user/removeRoleForBatch',
  REGISTER_LIST: '/manage/userRegisterReqLog/list',
  USER_COMPANY_LIST: '/manage/userCompany/findList',
  MANAGE_ACTIVATE: '/manage/userRegisterReqLog/activate',
  REGISTER_EXPORT: '/manage/userRegisterReqLog/export',
  DOWNLOAD: '/auth/public/download_file',
  GET_FILE_FLOW: '/auth/public/getFileFlow',
  DEL_USER_COMPANY: '/manage/userCompany/delete',
  UPLOAD: '/manage/userCompany/upload',
  GET_USER_COMPANY_DETAIL: '/manage/userCompany/find'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/accounts.js